/**
 * Util function check if object is undefine or null.
 * @param object
 * @returns
 */
export function isNullOrUndefined(object) {
    if (object === null || object === undefined) {
        return true;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=IsNullOrUndefined.js.map